import { render, staticRenderFns } from "./WarehouseStaff.vue?vue&type=template&id=0e27ff05&"
import script from "./WarehouseStaff.vue?vue&type=script&lang=js&"
export * from "./WarehouseStaff.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports